import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SharedModule } from "@shared/shared.module";
import { FuseMainComponent } from "./main.component";
import { FooterOneComponent } from './footer/footer-one/footer-one.component';
import { CopyrightComponent } from './footer/widgets/copyright/copyright.component';
import { InformationComponent } from './footer/widgets/information/information.component';
import { SocialComponent } from './footer/widgets/social/social.component';
import { WhyWeChooseComponent } from './footer/widgets/why-we-choose/why-we-choose.component';
import { MainHeaderComponent } from './header/main-header.component';
import { ModalsModule } from "@shared/features/modals/modals.module";
import { CustomFooterComponent } from './footer/custom-footer/custom-footer.component';
import { SearchBarComponent } from "./header/widgets/search-bar/search-bar.component";
import { MenuComponent } from "./header/widgets/menu/menu.component";
import { CartSummaryComponent } from "./header/widgets/cart-summary/cart-summary.component";

@NgModule({
    imports: [
        SharedModule,
        ModalsModule,
        RouterModule,
        FuseMainComponent,
        FooterOneComponent,
        CopyrightComponent,
        InformationComponent,
        SocialComponent,
        WhyWeChooseComponent,
        MainHeaderComponent,
        SearchBarComponent,
        CartSummaryComponent,
        MenuComponent,
        CustomFooterComponent,
    ],
    exports: [
        FuseMainComponent,
    ]
})

export class FuseMainModule { }